import { logger } from '../logger';

const PREFIX = '@atlassian.search-ai.';

const setString = (key: string, value: string) => {
	try {
		window.localStorage.setItem(`${PREFIX}${key}`, value);
	} catch (error) {
		logger.error(error);
	}
};

const getString = (key: string): string | null => {
	return window.localStorage.getItem(`${PREFIX}${key}`);
};

export const localStore = {
	getString,
	setString,
};
